import { Constants } from '@/constants/common';
export class Console {
    static showLogs() {
        try {
            return !!sessionStorage.getItem(Constants.DEBUG_MODE_KEY) || !!sessionStorage.getItem(Constants.FORCE_DEBUG_MODE_KEY);
        }
        catch (err) {
            Console.catch('Error in showLogs: ', err);
            return false;
        }
    }
}
Console.log = Console.showLogs() ? console.log : () => { };
Console.warn = Console.showLogs() ? console.warn : () => { };
Console.error = Console.showLogs() ? console.error : () => { };
Console.debug = Console.showLogs() ? console.debug : () => { };
Console.info = Console.showLogs() ? console.info : () => { };
Console.logsEnabled = true;
// to show error catched in try catch
Console.catch = (message, error) => {
    try {
        if (Console.logsEnabled) {
            if (error !== undefined) {
                console.warn(Constants.LOG_PREFIX, message, error);
            }
            else {
                console.warn(Constants.LOG_PREFIX, message);
            }
        }
    }
    catch (err) {
        // do nothing
    }
};
